import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const FreeHotel = (props) => {
  const {
    id,
    bgImage,
    flyToMarker,
    hotelInfo,
    hotelName,
    location,
    phoneNumber,
    address,
    category,
    other,
  } = props;
  return (
    <div
      className='freeDiv'
      id={id}
      style={{
        backgroundImage: 'url(' + bgImage + ')',
      }}
    >
      <span
        className='fa-layers fa-fw fa-2x markerCircle'
        onClick={flyToMarker}
        key='map'
      >
        <FontAwesomeIcon icon={['fas', 'circle']} className='circle' />
        <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className='marker' />
      </span>
      <div className='freeInfoDiv' onClick={hotelInfo}>
        <span className='freeHotelName'>{hotelName}</span> <br />
        <br />
        <span className='freeHotelCity'>
          {location}, {other.country}
        </span>{' '}
        <br />
        <span className='freeHotelAddr'>
          {other.zip}, {other.addr1} {other.addr2}
        </span>{' '}
        <br />
        <br />
        <span className='freeHotelPhone'>{phoneNumber}</span> <br />
        <span className='freeHotelPhone'>{other.email}</span> <br />
        <span className='freeHotelPhone'>{other.web_url}</span> <br />
        <br />
        <span className='moreInfo'>View Now ></span>
        <br />
      </div>
    </div>
  );
};

FreeHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
  hotelName: PropTypes.string,
  location: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  category: PropTypes.string,
  other: PropTypes.object,
};

FreeHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
  hotelName: '',
  location: '',
  phoneNumber: '',
  address: '',
  category: '',
  other: [],
};

export default FreeHotel;
